// Rol predikatlari — backend `services/roles.js` bilan bir xil ro'yxat (usta roli sinonimlari).
// Bazadagi kanonik qiymat 'provider', lekin eski/mobil ma'lumotda o'zbekcha/inglizcha
// sinonimlar bo'lishi mumkin — hammasi bitta tushuncha.
const PROVIDER_ROLES = ['provider', 'usta', 'ijrochi', 'master', 'specialist', 'executor'];

export function isProviderRole(role) {
  return PROVIDER_ROLES.includes(String(role || '').trim().toLowerCase());
}

export function isAdminRole(role) {
  return String(role || '').trim().toLowerCase() === 'admin';
}

// Saqlashdan oldin rolni kanonik ko'rinishga keltiradi (guardlar 'provider' / 'admin' ga qaraydi).
export function normalizeRole(role) {
  if (isProviderRole(role)) return 'provider';
  if (isAdminRole(role)) return 'admin';
  return role;
}
